import { ArraySchema, filter, Schema, type } from "@colyseus/schema"
import { Client } from "colyseus"

import { isArrayEqual } from "../../utils"
import { CustomsClass } from "./customs"
import { GameState } from "./game"
import { CardDataClass } from "./сard"
import { User } from "@telegram-apps/sdk"

export type PlayerState = undefined | "chooseColor" | "tookCards"

export type PlayerStatus = "online" | "offline" | "afk"

export class StatisticsClass extends Schema {
  @type("number") win: number
  @type("number") lose: number

  constructor(win = 0, lose = 0) {
    super()

    this.win = win
    this.lose = lose
  }
}

export class PaidFeaturesClass extends Schema {
  @type("boolean") blackCard: boolean

  constructor(blackCard = false) {
    super()

    this.blackCard = blackCard
  }
}

export class PlayerClass extends Schema {
  @type("number") id!: number
  @type("number") coreId!: number

  @type("string") name!: string
  @type("string") username?: string
  @type("string") image!: string

  @type("number") balance!: number
  @type("number") balanceCurrency!: number
  @type("number") balanceDecimals!: number

  @type("number") bet!: number
  @type("number") betCurrency!: number
  @type("number") betDecimals!: number

  @type("number") specialBalance!: number
  @type("number") specialBalanceDecimals!: number

  @type(StatisticsClass) statistics = new StatisticsClass()
  @type(CustomsClass) customs = new CustomsClass()
  @type(["string"]) dignities = new ArraySchema<string>()
  @type(PaidFeaturesClass) paidFeatures = new PaidFeaturesClass()

  @type("number") lastPing!: number

  @type("string") sessionId!: string

  @type("number") coreSessionId!: number

  @type("boolean") isOwner!: boolean
}

export type PlayerClassType = InstanceType<typeof PlayerClass>

export class PlayerDataClass extends Schema {
  @type(PlayerClass) info = new PlayerClass()

  @type("string") status!: PlayerStatus

  @type("boolean") ready!: boolean
  @type("boolean") playAgain = false

  @type("number") lastActivity!: number

  @type("number") points?: number
  @type("number") winAmount!: number

  @type("boolean") shoutedUno?: boolean

  @type("number") surrenderAt?: number

  @type("string") playerState!: PlayerState

  @filter(function (
    client: PlayerClient,
    value: ArraySchema<CardDataClass>,
    root: GameState
  ) {
    const player = root.players.get(String(client.userData?.id))

    if (player?.cards === undefined) return false

    return isArrayEqual([...player.cards], [...value])
  })
  @type([CardDataClass])
  cards = new ArraySchema<CardDataClass>()

  @type("number") cardsCount?: number

  @type("boolean") isFirstGame?: boolean
  @type("number") referrerId?: number
}

export type PlayerDataClassType = InstanceType<typeof PlayerDataClass>

export interface PlayerData {
  id: number
  name: string
  personalBetCurrency: number
  sessionId: string
  username?: string
}

export type PlayerClient = Client<PlayerData, User> & { userData: PlayerData }
